App.filter('checkDash', function () {
    return function (str) {
        str = str || '';
        if (str.length === 5) {
            var first = str.substring(0, 2);
            var last = str.substring(2, 5);
            str = first + '-' + last;
        }
        return str;
    };
})